import axios from "axios";

export function getcompanyMembersApi({query, companyId}: {query: string, companyId: number}){
    return axios.get(`/api/v1/company/search-members/${companyId}`, {params: {query}});
}

export function searchFreeMembersApi({query}: {query: string}){
    return axios.get('/api/v1/company/search-free-members', {params: {query}})
}

export function removeCompanyMemberApi({userId}: {userId: number}){
    return axios.put('/api/v1/company/remove-member', {userId});
}

export function addCompanyMemberApi({userId, companyId}: {userId: number, companyId: number}){
    return axios.put('/api/v1/company/add-member', {userId, companyId});
}

export function allocateCompanyMemberStorage({userId, storage, companyId}: {userId: number, storage: number, companyId: number}){
    return axios.put('/api/v1/company/storage', {userId, storage, companyId});
}

export function inviteNewCompanyUserApi({email}: {email: string}){
    return axios.post('/api/v1/company/invite-company-user', {email})
}

export function deleteCompanyInviteApi({ email }: { email: string }) {
    return axios.delete('/api/v1/company/delete-company-invite', {data: {email}});
}